import {useState, useRef, useCallback, useLayoutEffect} from 'react'

const useStickyHeader = (defaultSticky = false) => {
  const tableRef = useRef(null)
  const [isSticky, setIsSticky] = useState(defaultSticky)

  const handleScroll = useCallback(() => {
    if (tableRef?.current) {
      setIsSticky(tableRef.current?.getBoundingClientRect().top <= 50)
    }
  }, [])

  useLayoutEffect(() => {
    window.addEventListener('scroll', handleScroll, true)

    return () => {
      window.removeEventListener('scroll', handleScroll, true)
    }
  }, [handleScroll])

  return {tableRef, isSticky}
}

export default useStickyHeader
